export default "<div class=\"tab\" [hidden]=\"!active\">\n  <ng-content></ng-content>\n</div>\n"